import React, { ReactNode } from "react";
import { Box, Divider } from "@mui/material";

const AlertHeaderWithDivider = (props: { children: ReactNode }) => {
  return (
    <Box>
      {props.children}
      <Divider />
    </Box>
  );
};

export default AlertHeaderWithDivider;
